import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hossein/b2b-shop/src/components/antdRegistry/antdRegistry.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootComp"] */ "/home/hossein/b2b-shop/src/components/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hossein/b2b-shop/src/utilities/styles.scss");
